import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { ReactNode } from 'react'

import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

type Props = {
  children: ReactNode
}

export function TidalCampaignTrackingCard(props: Props) {
  const { children } = props

  return (
    <Paper sx={{ width: '384px', padding: (theme: Theme) => theme.spacing(2) }}>
      <Stack alignItems="center" gap={2} width="100%">
        {children}
      </Stack>
    </Paper>
  )
}
